<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'transferAdd',
    components: {
      baseEdit,
    },
  };
</script>
